import React, {useState, useEffect, useRef} from 'react';
import {FilterMatchMode} from 'primereact/api';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {useTranslation} from 'react-i18next';
import {useHistory} from "react-router-dom";
import {Dialog} from 'primereact/dialog';
import {connect} from "react-redux";
import moment from 'moment';
import {exportExcel, exportPdf} from "../shared/utility";
import {SplitButton} from "primereact/splitbutton";
import NewDebtDialogue from "./dialogues/NewDebtDialogue";
import {DebtService} from "../service/DebtService";


const DebtsPage = (props) => {
    const {t, i18n} = useTranslation();

    let emptyDebtItem = {
        id: null,
        fullName: null,
        createdDate: null,
        dueDate: null,
        notes: null,
        totalAmount: null,
        status: null,
    };

    const [debt, setDebt] = useState(emptyDebtItem);
    const [debts, setDebts] = useState(null);
    const [selectedDebt, setSelectedDebt] = useState(null);
    const [debtDialog, setDebtDialog] = useState(false);
    const [deleteDebtDialog, setDeleteDebtDialog] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [filters, setFilters] = useState({
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const exportOptions = [
        {
            label: 'Excel',
            icon: 'pi pi-file-excel',
            command: () => {
                exportExcel(debts);
            }
        },
        {
            label: 'CSV',
            icon: 'pi pi-file',
            command: () => {
                exportCSV();
            }
        }
    ];

    const cols = [
        {field: 'id', header: t('id')},
        {field: 'fullName', header: t('person')},
        {field: 'totalAmount', header: t('total_amount')},
        {field: 'dueDate', header: t('date')},
        {field: 'notes', header: t('notes')},
        {field: 'createdDate', header: t('creation_date')},
    ];

    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);
    const dt = useRef(null);

    const debtService = new DebtService();

    useEffect(() => {
        debtService.getDebts(props.partnerId).then(data => {
            setDebts(fixDateField(data.content));
            setLoading(false)
        });
    }, []);

    const fixDateField = (data) => {
        return [...data || []].map(d => {
            d.date = new Date(d.date);
            return d;
        });
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = {...filters};
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const addDebt = () => {
        setDebt(emptyDebtItem);
        setSubmitted(false);
        setDebtDialog(true);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setDebtDialog(false);
        setDeleteDebtDialog(false);
    }

    const confirmDeleteDebt = (debt) => {
        setDebt(debt);
        setDeleteDebtDialog(true);
    }

    const deleteDebt = () => {
        debtService.deleteDebt(debt.id)
            .then(() => {
                let _debts = debts.filter(val => val.id !== debt.id);
                setDebts(_debts);
                setDeleteDebtDialog(false);
                setDebt(emptyDebtItem);
            })
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    }

    const onSelectionDetail = (e) => {
        setSelectedDebt(e.value)
        setDebtDialog(true);
    }

    const dateBodyTemplate = (rowData) => {
        if (rowData.dueDate != null) {
            return moment(rowData.dueDate).format('DD.MM.YYYY HH:mm')
        }
        return ''
    }

    const creationDateBodyTemplate = (rowData) => {
        if (rowData.createdDate != null) {
            return moment(rowData.createdDate).format('DD.MM.YYYY HH:mm')
        }
        return ''
    }

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between align-items-center">
                <h5 className="m-0">{t('debts')}</h5>
                <span className="p-input-icon-right">
                    <i className="pi pi-add"/>
                    <Button label={t('add')} icon="pi pi-plus" className="p-button-success" onClick={addDebt}/>
                    <span> </span>
                    <i className="pi pi-export"/>
                    <SplitButton label={t('export')} icon="pi pi-download" className="p-button-help"
                                 style={{marginRight: "10px"}} onClick={() => exportPdf(cols, debts)}
                                 model={exportOptions}/>
                    <span> </span>
                    <i className="pi pi-search"/>
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder={t('search')}/>
                </span>
            </div>
        )
    }

    const header = renderHeader();
    let history = useHistory();

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                {/*<Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2"
                        onClick={() => editDebt(rowData)}/>*/}
                <Button icon="pi pi-trash" className="p-button-rounded p-button-warning"
                        onClick={() => confirmDeleteDebt(rowData)}/>
            </React.Fragment>
        );
    }

    const deleteDebtDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDialog}/>
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteDebt}/>
        </React.Fragment>
    );

    return (
        <div className="datatable-doc-demo col-12">
            <div className="card">
                <DataTable value={debts} ref={dt} paginator className="p-datatable-products" header={header} rows={8}
                           paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                           rowsPerPageOptions={[10, 25, 50]}
                           dataKey="id" rowHover selection={selectedDebt} onSelectionChange={onSelectionDetail}
                           filters={filters} filterDisplay="menu" loading={loading} responsiveLayout="scroll"
                           emptyMessage={t('no_debt_found')}
                           currentPageReportTemplate={t('Showing {first} to {last} of {totalRecords} entries')}>
                    <Column field="fullName" header={t('person')} sortable></Column>
                    <Column field="totalAmount" header={t('total_amount')} sortable dataType="count"></Column>
                    <Column field="dueDate" header={t('date')} sortable dataType="date" body={dateBodyTemplate}></Column>
                    <Column field="notes" header={t('notes')} sortable></Column>
                    <Column field="createdDate" header={t('creation_date')} sortable dataType="date"
                            body={creationDateBodyTemplate}></Column>
                    <Column body={actionBodyTemplate} exportable={false} style={{minWidth: '8rem'}}></Column>
                </DataTable>
            </div>
            <NewDebtDialogue visible={debtDialog} onHide={setDebtDialog}/>
            <Dialog visible={deleteDebtDialog} style={{width: '450px'}} header={t('confirm')} modal
                    footer={deleteDebtDialogFooter} onHide={hideDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{fontSize: '2rem'}}/>
                    {debt && <span>{t('confirm_delete')}</span>}
                </div>
            </Dialog>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        partnerId: state.auth.userDetails.partner.id
    };
};

export default connect(mapStateToProps, null)((DebtsPage));
